<template>
  <div class="editor-header-container">
    <div class="header-left-content">
      <i
        class="iconfont iconchevron-left"
        @click="clickMyResume"
      ></i>
      <span
        class="my-resume-title"
        @click="clickMyResume"
      >
        我的简历
      </span>
      <div
        class="resume-name"
        @click="clickRenameResume"
      >
        {{ resumeBasicInfo.cv_name }}
      </div>
      <img
        src="https://logo.wondercv.com/banners/opwyh2o8KFhSdur.png"
        alt=""
        class="edit-image"
        @click="clickRenameResume"
      />
      <div v-if="!['sample', 'template'].includes(cvDetail.basic_info.kind)" class="save-loading-container flex items-center">
        <template v-if="saveLoading">
          <img
            src="https://files.wondercv.com/icon/loading.gif"
            alt=""
            class="save-loading-image"
          />
          <span class="normal-text">正在保存</span>
        </template>
        <template v-else>
          <i class="iconfont iconyibaocun"></i>
          <span class="normal-text">已保存 {{ saveTime }}</span>
        </template>
      </div>
    </div>
    <div class="header-right-content">
      <ResumeStyleMenu
        @clickEditModuleName="clickEditModuleName"
        @clickDeleteModule="clickDeleteModule"
        @editItem="editItem"
        @changeSaveLoading="changeSaveLoading"
      />
      <div
        v-if="!resumeBasicInfo.trans_cv_id"
        class="resume-translation"
        @click="clickTranslationResume"
      >
        翻译
      </div>
      <div class="resume-download">
        下载
        <div class="resume-download-popup-wrapper">
          <div class="resume-download-popup">
            <div
              v-for="item in popupList"
              :key="item.type"
              class="popup-item"
              @click="clickPopupItem(item)"
            >
              <img
                :src="item.image"
                alt=""
              />
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="resume-more">
        <i class="iconfont iconmore-horizontal fontb"></i>
        <ResumeMore
          class="resume-more-content"
          @clickChangeTheme="clickChangeTheme"
          @copyResume="copyResume"
          @clickMergeResume="clickMergeResume"
          @clickShareWx="clickShareWx"
          @clickSendEmail="clickSendEmail"
          @clickDelete="clickDelete"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import ResumeStyleMenu from '../ResumeStyleMenu/ResumeStyleMenu.vue';
import ResumeMore from '../ResumeMore/ResumeMore.vue';
import moment from 'moment';

let timer = null

export default {
  name: 'EditorHeader',
  props: {
    saveLoading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ResumeStyleMenu,
    ResumeMore,
  },
  data() {
    return {
      popupList: [
        {
          name: '下载 PDF',
          image: 'https://logo.wondercv.com/banners/HMt5myTLSPEKAOb.png',
          type: 'pdf',
        },
        {
          name: '下载 PNG',
          image: 'https://logo.wondercv.com/banners/TPevaKTZbVmM7X8.png',
          type: 'img',
        },
      ],
      saveTime: '',
    };
  },
  computed: {
    ...mapState('editor', ['cvDetail']),
    resumeBasicInfo() {
      return this.cvDetail.basic_info || {};
    },
  },
  watch: {
    'cvDetail.basic_info.updated_at': {
      handler() {
        this.formatTimeDiff()
      },
      immediate: true,
    },
  },
  methods: {
    formatTimeDiff() {
      const { basic_info } = this.cvDetail;
      if (!basic_info.updated_at) return '';
      const now = moment();
      const time = moment(basic_info.updated_at);
      const diffMinutes = now.diff(time, 'minutes');
      const diffHours = now.diff(time, 'hours');

      // 判断是否为昨天（48小时内且跨天）
      const isYesterday = time.isSame(now.clone().subtract(1, 'day'), 'day');
      // 判断是否为前天（72小时内且跨两天）
      const isDayBeforeYesterday = time.isSame(now.clone().subtract(2, 'day'), 'day');

      if (diffMinutes < 1) {
        this.saveTime = '刚刚';
      } else if (diffHours < 1) {
        this.saveTime = `${diffMinutes}分钟以前`;
      } else if (diffHours < 24) {
        this.saveTime = `${diffHours}小时以前`;
      } else if (isYesterday) {
        this.saveTime = `昨天 ${time.format('HH:mm')}`;
      } else if (isDayBeforeYesterday) {
        this.saveTime = `前天 ${time.format('HH:mm')}`;
      } else if (time.isSame(now, 'year')) {
        this.saveTime = time.format('MM月DD日 HH:mm');
      } else {
        this.saveTime = time.format('YYYY年MM月DD日 HH:mm');
      }
    },
    changeSaveLoading(value) {
      this.$emit('changeSaveLoading', value);
    },
    clickRenameResume() {
      this.$emit('clickRenameResume');
    },
    clickPopupItem(item) {
      this.$emit('clickPopupItem', item);
    },
    clickTranslationResume() {
      this.$emit('clickTranslationResume');
    },
    clickChangeTheme() {
      this.$emit('clickChangeTheme');
    },
    copyResume() {
      this.$emit('copyResume');
    },
    clickMergeResume() {
      this.$emit('clickMergeResume');
    },
    clickShareWx() {
      this.$emit('clickShareWx');
    },
    clickSendEmail() {
      this.$emit('clickSendEmail');
    },
    clickDelete() {
      this.$emit('clickDelete');
    },
    clickMyResume() {
      this.$emit('clickMyResume');
    },
    clickEditModuleName(item) {
      this.$emit('clickEditModuleName', item);
    },
    clickDeleteModule(item) {
      this.$emit('clickDeleteModule', item);
    },
    editItem(item) {
      this.$emit('editItem', item);
    },
  },
  mounted() {
    timer = setInterval(() => {
      this.formatTimeDiff()
    }, 1000)
  },
  beforeDestroy() {
    clearInterval(timer)
  }
};
</script>
<style lang="scss" scoped>
@mixin ellipsis($width) {
  max-width: $width;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.editor-header-container {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-width: 1400px;
  height: 50px;
  background-color: #1f232a;
  padding: 0 20px;
  box-sizing: border-box;
  top: 0;
  left: 0;
  z-index: 299;
  .header-left-content {
    display: flex;
    align-items: center;
    height: 100%;
    color: #ffffff;
    font-size: 14px;
    cursor: pointer;
    .iconchevron-left {
      margin-right: 4px;
      font-size: 18px;
    }
    .resume-name {
      @include ellipsis(120px);
      margin-left: 24px;
    }
    .edit-image {
      margin-left: 4px;
      width: 12px;
      object-fit: cover;
    }
    .save-loading-container {
      color: #8b95a7;
      margin-left: 24px;
      .save-loading-image {
        width: 16px;
        height: 16px;
        margin-right: 6px;
      }
      .iconyibaocun {
        margin-right: 6px;
        font-size: 14px;
      }
      .normal-text {
        @include ellipsis(95px);
      }
    }
  }
  .header-right-content {
    display: flex;
    align-items: center;
    .resume-translation,
    .resume-download,
    .resume-more {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 76px;
      height: 30px;
      border-radius: 15px;
      border: 1px solid rgba(255, 255, 255, 0.4);
      margin-left: 32px;
      cursor: pointer;
      color: #fff;
      box-sizing: border-box;
      &.resume-download {
        position: relative;
        background: linear-gradient(270deg, #e15d3f 0%, #febf5d 100%);
        border: none;
        margin-left: 12px;
        &:hover {
          .resume-download-popup-wrapper {
            display: block;
          }
        }
        .resume-download-popup-wrapper {
          position: absolute;
          top: 30px;
          left: 50%;
          transform: translateX(-50%);
          padding-top: 6px;
          display: none;
          .resume-download-popup {
            background: linear-gradient(45deg, #272b33 0%, #272b33 62%, #523433 100%);
            border-radius: 8px;
            border: 1px solid #383e49;
            backdrop-filter: blur(8px);
            width: 120px;
            overflow: hidden;
            .popup-item {
              display: flex;
              align-items: center;
              justify-content: center;
              height: 46px;
              width: 100%;
              cursor: pointer;
              &:hover {
                background-color: rgba(255, 255, 255, 0.06);
              }
              img {
                width: 15px;
                height: 18px;
                margin-right: 6px;
              }
            }
          }
        }
      }
      &.resume-more {
        position: relative;
        margin-left: 12px;
        color: #fff;
        .iconfont {
          font-size: 24px;
          font-weight: bold;
        }
        .resume-more-content {
          position: absolute;
          top: 30px;
          right: 0;
          display: none;
        }
        &:hover {
          .resume-more-content {
            display: block;
          }
        }
      }
    }
  }
}

@media(min-width: 1450px) {
  .editor-header-container {
    .header-left-content {
      .save-loading-container {
        .normal-text {
          max-width: fit-content;
        }
      }
    }
  }
}
</style>
